<template>
    <div class="schedule-detail-container">
        <!-- 面包屑导航 -->
        <div class="breadcrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/Welcome' }">
                    <i class="el-icon-s-home"></i>首页
                </el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/expoScheduleList' }">
                    <i class="el-icon-date"></i>展会排期列表
                </el-breadcrumb-item>
                <el-breadcrumb-item>展会排期详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <!-- 主内容卡片 -->
        <el-card class="main-card" shadow="hover" v-loading="loading">
            <!-- 头部操作区域 -->
            <div class="card-header">
                <div class="header-title">
                    <i class="el-icon-s-data"></i>
                    <span>展会排期详情</span>
                    <el-tag
                            :type="statusTagType"
                            size="medium"
                            style="margin-left: 10px;"
                    >
                        {{ statusText }}
                    </el-tag>
                </div>
                <div class="header-actions">
                    <el-button size="mini" icon="el-icon-edit" @click="handleEdit">编辑</el-button>
                    <el-button size="mini" icon="el-icon-back" @click="goBack">返回</el-button>
                </div>
            </div>

            <!-- 详情内容 -->
            <div class="detail-content">
                <!-- 基本信息 -->
                <div class="detail-section">
                    <div class="section-title">
                        <i class="el-icon-info"></i>基本信息
                    </div>
                    <el-row :gutter="20" class="info-row">
                        <el-col :span="8">
                            <div class="info-item">
                                <label class="info-label">排期名称：</label>
                                <span class="info-value">{{ detailData.title || '-' }}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="info-item">
                                <label class="info-label">展会名称：</label>
                                <span class="info-value">{{ detailData.exhibition ? detailData.exhibition.title : '-' }}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="info-item">
                                <label class="info-label">所属展馆：</label>
                                <span class="info-value">{{ detailData.venue ? detailData.venue.title : '-' }}</span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" class="info-row">
                        <el-col :span="24">
                            <div class="info-item">
                                <label class="info-label">排期描述：</label>
                                <span class="info-value">{{ detailData.description || '-' }}</span>
                            </div>
                        </el-col>
                    </el-row>
                </div>

                <!-- 时间信息 -->
                <div class="detail-section">
                    <div class="section-title">
                        <i class="el-icon-time"></i>时间信息
                    </div>
                    <el-row :gutter="20" class="info-row">
                        <el-col :span="6">
                            <div class="time-card">
                                <div class="time-icon">
                                    <i class="el-icon-timer"></i>
                                </div>
                                <div class="time-content">
                                    <div class="time-label">开始时间</div>
                                    <div class="time-value">{{ detailData.start_time | dateFormat }}</div>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="time-card">
                                <div class="time-icon">
                                    <i class="el-icon-timer"></i>
                                </div>
                                <div class="time-content">
                                    <div class="time-label">结束时间</div>
                                    <div class="time-value">{{ detailData.end_time | dateFormat }}</div>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="time-card">
                                <div class="time-icon">
                                    <i class="el-icon-setting"></i>
                                </div>
                                <div class="time-content">
                                    <div class="time-label">布展时间</div>
                                    <div class="time-value">{{ detailData.setup_start_time | dateFormat }}</div>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="time-card">
                                <div class="time-icon">
                                    <i class="el-icon-setting"></i>
                                </div>
                                <div class="time-content">
                                    <div class="time-label">撤展时间</div>
                                    <div class="time-value">{{ detailData.teardown_end_time | dateFormat }}</div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" class="info-row">
                        <el-col :span="24">
                            <div class="duration-info">
                                <div class="duration-item">
                                    <label>展会持续时间：</label>
                                    <span class="duration-value">{{ calculateDuration(detailData.start_time, detailData.end_time) }}</span>
                                </div>
                                <div class="duration-item" v-if="detailData.setup_start_time && detailData.teardown_end_time">
                                    <label>总占用时间：</label>
                                    <span class="duration-value">{{ calculateDuration(detailData.setup_start_time, detailData.teardown_end_time) }}</span>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>

                <!-- 展位信息 -->
                <div class="detail-section">
                    <div class="section-title">
                        <i class="el-icon-s-shop"></i>展位信息
                    </div>
                    <el-row :gutter="20" class="info-row">
                        <el-col :span="8">
                            <div class="booth-stat-card">
                                <div class="stat-icon total">
                                    <i class="el-icon-s-grid"></i>
                                </div>
                                <div class="stat-content">
                                    <div class="stat-value">{{ detailData.total_booths || 0 }}</div>
                                    <div class="stat-label">总展位数</div>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="booth-stat-card">
                                <div class="stat-icon available">
                                    <i class="el-icon-s-claim"></i>
                                </div>
                                <div class="stat-content">
                                    <div class="stat-value">{{ detailData.available_booths || 0 }}</div>
                                    <div class="stat-label">可用展位</div>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="booth-stat-card">
                                <div class="stat-icon price">
                                    <i class="el-icon-money"></i>
                                </div>
                                <div class="stat-content">
                                    <div class="stat-value">{{ detailData.standard_price ? '¥' + detailData.standard_price : '-' }}</div>
                                    <div class="stat-label">标准展位价</div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" class="info-row">
                        <el-col :span="24">
                            <div class="booth-progress">
                                <div class="progress-header">
                                    <span>展位预订进度</span>
                                    <span class="progress-percent">{{ boothUsagePercent }}%</span>
                                </div>
                                <el-progress
                                        :percentage="boothUsagePercent"
                                        :color="boothUsageColor"
                                        :show-text="false"
                                ></el-progress>
                                <div class="progress-stats">
                                    <span>已预订：{{ bookedBooths }} 个</span>
                                    <span>剩余：{{ detailData.available_booths || 0 }} 个</span>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>

                <!-- 展会详情 -->
                <div class="detail-section" v-if="detailData.exhibition">
                    <div class="section-title">
                        <i class="el-icon-s-promotion"></i>展会详情
                    </div>
                    <el-row :gutter="20" class="info-row">
                        <el-col :span="8">
                            <div class="info-item">
                                <label class="info-label">展会分类：</label>
                                <span class="info-value">
                  <el-tag v-if="detailData.exhibition.category" size="mini">
                    {{ detailData.exhibition.category.name }}
                  </el-tag>
                  <span v-else>-</span>
                </span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="info-item">
                                <label class="info-label">展会规模：</label>
                                <span class="info-value">{{ detailData.exhibition.scale || '-' }}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="info-item">
                                <label class="info-label">预计观众：</label>
                                <span class="info-value">{{ detailData.exhibition.expected_visitors || '-' }}</span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" class="info-row">
                        <el-col :span="24">
                            <div class="info-item">
                                <label class="info-label">展会介绍：</label>
                                <div class="info-content">{{ detailData.exhibition.description || '-' }}</div>
                            </div>
                        </el-col>
                    </el-row>
                </div>

                <!-- 展馆详情 -->
                <div class="detail-section" v-if="detailData.venue">
                    <div class="section-title">
                        <i class="el-icon-office-building"></i>展馆详情
                    </div>
                    <el-row :gutter="20" class="info-row">
                        <el-col :span="8">
                            <div class="info-item">
                                <label class="info-label">展馆面积：</label>
                                <span class="info-value">{{ detailData.venue.area ? detailData.venue.area + '㎡' : '-' }}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="info-item">
                                <label class="info-label">容纳人数：</label>
                                <span class="info-value">{{ detailData.venue.capacity ? detailData.venue.capacity + '人' : '-' }}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="info-item">
                                <label class="info-label">联系电话：</label>
                                <span class="info-value">{{ detailData.venue.phone || '-' }}</span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" class="info-row">
                        <el-col :span="24">
                            <div class="info-item">
                                <label class="info-label">展馆地址：</label>
                                <span class="info-value">{{ detailData.venue.address || '-' }}</span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" class="info-row">
                        <el-col :span="24">
                            <div class="info-item">
                                <label class="info-label">配套设施：</label>
                                <div class="facilities-list">
                                    <el-tag
                                            v-for="facility in venueFacilities"
                                            :key="facility.value"
                                            :type="hasVenueFacility(facility.value) ? 'success' : 'info'"
                                            size="small"
                                            style="margin-right: 8px; margin-bottom: 5px;"
                                    >
                                        {{ facility.label }}
                                    </el-tag>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>

                <!-- 平面图 -->
                <div class="detail-section" v-if="detailData.layout_image">
                    <div class="section-title">
                        <i class="el-icon-map-location"></i>展位平面图
                    </div>
                    <div class="layout-image-container">
                        <el-image
                                :src="detailData.layout_image"
                                :preview-src-list="[detailData.layout_image]"
                                fit="contain"
                                class="layout-image"
                        >
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                            </div>
                        </el-image>
                    </div>
                </div>

                <!-- 注意事项 -->
                <div class="detail-section" v-if="detailData.notes">
                    <div class="section-title">
                        <i class="el-icon-warning"></i>注意事项
                    </div>
                    <div class="notes-content">
                        {{ detailData.notes }}
                    </div>
                </div>

                <!-- 系统信息 -->
                <div class="detail-section">
                    <div class="section-title">
                        <i class="el-icon-setting"></i>系统信息
                    </div>
                    <el-row :gutter="20" class="info-row">
                        <el-col :span="8">
                            <div class="info-item">
                                <label class="info-label">创建时间：</label>
                                <span class="info-value">{{ detailData.add_time | dateFormat }}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="info-item">
                                <label class="info-label">更新时间：</label>
                                <span class="info-value">{{ detailData.update_time | dateFormat }}</span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="info-item">
                                <label class="info-label">操作人员：</label>
                                <span class="info-value">{{ detailData.operator ? detailData.operator.name : '-' }}</span>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        name: "ScheduleDetail",
        data() {
            return {
                loading: false,
                scheduleId: null,
                detailData: {},

                // 展馆设施列表
                venueFacilities: [
                    { label: '停车场', value: 'parking' },
                    { label: '餐饮服务', value: 'catering' },
                    { label: 'WiFi', value: 'wifi' },
                    { label: '空调系统', value: 'air_conditioning' },
                    { label: '安保服务', value: 'security' },
                    { label: '物流服务', value: 'logistics' },
                    { label: '会议室', value: 'meeting_room' },
                    { label: '休息区', value: 'rest_area' }
                ]
            };
        },
        computed: {
            statusText() {
                const statusMap = {
                    0: '未开始',
                    1: '进行中',
                    2: '已结束',
                    3: '已取消'
                };
                return statusMap[this.detailData.status] || '未知状态';
            },
            statusTagType() {
                const typeMap = {
                    0: 'info',
                    1: 'success',
                    2: 'warning',
                    3: 'danger'
                };
                return typeMap[this.detailData.status] || 'info';
            },
            // 计算已预订展位数
            bookedBooths() {
                return (this.detailData.total_booths || 0) - (this.detailData.available_booths || 0);
            },
            // 计算展位使用百分比
            boothUsagePercent() {
                if (!this.detailData.total_booths) return 0;
                return Math.round((this.bookedBooths / this.detailData.total_booths) * 100);
            },
            // 进度条颜色
            boothUsageColor() {
                if (this.boothUsagePercent < 50) {
                    return '#67C23A'; // 绿色
                } else if (this.boothUsagePercent < 80) {
                    return '#E6A23C'; // 黄色
                } else {
                    return '#F56C6C'; // 红色
                }
            }
        },
        created() {
            this.scheduleId = this.$route.query.id;
            if (this.scheduleId) {
                this.getScheduleDetail();
            } else {
                this.$message.error('排期ID不存在');
                this.goBack();
            }
        },
        filters: {
            // 时间格式化
            dateFormat(add_time) {
                if (!add_time) return "-";
                return moment(add_time * 1000).format("YYYY-MM-DD HH:mm");
            }
        },
        methods: {
            // 获取排期详情
            getScheduleDetail() {
                this.loading = true;
                const param = {
                    company_id: sessionStorage.getItem('company_id'),
                    access_token: sessionStorage.getItem('token'),
                    id: this.scheduleId
                }

                this.$axios.findExpoScheduleOne(param).then(res => {
                    this.loading = false;
                    if (res.code == 200) {
                        this.detailData = res.data || {};
                    } else {
                        this.$message.error(res.msg || '获取排期详情失败');
                        this.goBack();
                    }
                }).catch(error => {
                    this.loading = false;
                    console.log(error);
                    this.$message.error('获取排期详情失败');
                    this.goBack();
                })
            },

            // 计算持续时间
            calculateDuration(startTime, endTime) {
                if (!startTime || !endTime) return "-";

                const start = moment(startTime * 1000);
                const end = moment(endTime * 1000);
                const duration = moment.duration(end.diff(start));

                const days = duration.days();
                const hours = duration.hours();
                const minutes = duration.minutes();

                let result = '';
                if (days > 0) {
                    result += `${days}天`;
                }
                if (hours > 0) {
                    result += `${hours}小时`;
                }
                if (minutes > 0 && days === 0) {
                    result += `${minutes}分钟`;
                }

                return result || '0分钟';
            },

            // 检查展馆设施
            hasVenueFacility(facilityValue) {
                if (!this.detailData.venue || !this.detailData.venue.facilities) return false;
                return this.detailData.venue.facilities.includes(facilityValue);
            },

            // 编辑排期
            handleEdit() {
                this.$router.push('/expoScheduleForm?id=' + this.scheduleId);
            },

            // 返回列表
            goBack() {
                this.$router.push('/expoScheduleList');
            }
        }
    };
</script>

<style scoped>
    .schedule-detail-container {
        padding: 20px;
        background-color: #f5f7fa;
        min-height: calc(100vh - 84px);
    }

    .breadcrumb-container {
        margin-bottom: 20px;
    }

    .main-card {
        border-radius: 8px;
        border: none;
    }

    .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 20px;
        border-bottom: 1px solid #ebeef5;
        margin-bottom: 20px;
    }

    .header-title {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        color: #303133;
    }

    .header-title i {
        margin-right: 8px;
        color: #409EFF;
    }

    .detail-content {
        max-width: 1200px;
        margin: 0 auto;
    }

    .detail-section {
        margin-bottom: 24px;
        padding: 20px;
        background: #fff;
        border-radius: 8px;
        border: 1px solid #ebeef5;
        position: relative;
    }

    .section-title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 20px;
        padding-bottom: 10px;
        border-bottom: 1px solid #ebeef5;
        display: flex;
        align-items: center;
    }

    .section-title i {
        margin-right: 8px;
        color: #409EFF;
    }

    .info-row {
        margin-bottom: 16px;
    }

    .info-row:last-child {
        margin-bottom: 0;
    }

    .info-item {
        display: flex;
        align-items: flex-start;
        min-height: 32px;
    }

    .info-label {
        font-weight: 500;
        color: #606266;
        min-width: 100px;
        text-align: right;
        margin-right: 12px;
        line-height: 32px;
    }

    .info-value {
        flex: 1;
        color: #303133;
        line-height: 32px;
        word-break: break-all;
    }

    .info-content {
        flex: 1;
        color: #303133;
        line-height: 1.6;
        padding: 8px 0;
    }

    /* 时间卡片样式 */
    .time-card {
        display: flex;
        align-items: center;
        padding: 16px;
        background: #f8f9fa;
        border-radius: 8px;
        border-left: 4px solid #409EFF;
    }

    .time-icon {
        margin-right: 12px;
        font-size: 24px;
        color: #409EFF;
    }

    .time-content {
        flex: 1;
    }

    .time-label {
        font-size: 12px;
        color: #909399;
        margin-bottom: 4px;
    }

    .time-value {
        font-size: 14px;
        font-weight: 600;
        color: #303133;
    }

    /* 持续时间信息 */
    .duration-info {
        display: flex;
        gap: 30px;
    }

    .duration-item {
        display: flex;
        align-items: center;
    }

    .duration-item label {
        font-weight: 500;
        color: #606266;
        margin-right: 8px;
    }

    .duration-value {
        color: #409EFF;
        font-weight: 600;
    }

    /* 展位统计卡片 */
    .booth-stat-card {
        display: flex;
        align-items: center;
        padding: 16px;
        background: #f8f9fa;
        border-radius: 8px;
    }

    .stat-icon {
        margin-right: 12px;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        color: white;
    }

    .stat-icon.total {
        background: #409EFF;
    }

    .stat-icon.available {
        background: #67C23A;
    }

    .stat-icon.price {
        background: #E6A23C;
    }

    .stat-content {
        flex: 1;
    }

    .stat-value {
        font-size: 24px;
        font-weight: 700;
        color: #303133;
        margin-bottom: 4px;
    }

    .stat-label {
        font-size: 12px;
        color: #909399;
    }

    /* 展位进度 */
    .booth-progress {
        background: #f8f9fa;
        padding: 16px;
        border-radius: 8px;
    }

    .progress-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;
        font-weight: 500;
    }

    .progress-percent {
        color: #409EFF;
        font-weight: 600;
    }

    .progress-stats {
        display: flex;
        justify-content: space-between;
        margin-top: 8px;
        font-size: 12px;
        color: #909399;
    }

    /* 设施列表 */
    .facilities-list {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }

    /* 平面图容器 */
    .layout-image-container {
        position: relative;
        width: 100%;
        max-width: 800px;
        margin: 16px auto 0;
        border: 1px solid #ebeef5;
        border-radius: 6px;
        overflow: hidden;
    }

    .layout-image {
        width: 100%;
        height: 400px;
        display: block;
    }

    /* 注意事项 */
    .notes-content {
        background: #fffbf0;
        border: 1px solid #fdf6ec;
        border-radius: 6px;
        padding: 16px;
        color: #e6a23c;
        line-height: 1.6;
    }

    .image-slot {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        background: #f5f7fa;
        color: #909399;
        font-size: 30px;
    }

    /* 响应式调整 */
    @media (max-width: 768px) {
        .schedule-detail-container {
            padding: 10px;
        }

        .card-header {
            flex-direction: column;
            align-items: flex-start;
        }

        .header-actions {
            margin-top: 10px;
        }

        .detail-section {
            padding: 15px;
        }

        .info-item {
            flex-direction: column;
            align-items: flex-start;
        }

        .info-label {
            text-align: left;
            margin-bottom: 4px;
            min-width: auto;
        }

        .info-value {
            width: 100%;
        }

        .time-card {
            margin-bottom: 10px;
        }

        .booth-stat-card {
            margin-bottom: 10px;
        }

        .duration-info {
            flex-direction: column;
            gap: 10px;
        }

        .layout-image {
            height: 300px;
        }
    }

    /* 打印样式 */
    @media print {
        .schedule-detail-container {
            background: white;
            padding: 0;
        }

        .breadcrumb-container,
        .header-actions {
            display: none;
        }

        .detail-section {
            break-inside: avoid;
            border: 1px solid #ddd;
        }
    }
</style>
